// Mock user/role fixtures for the Edit Role page — used as a fallback when the
// employees endpoint is unavailable.
import { permissionCategories } from './permissionCategories';

export interface UserData {
  id: string;
  name: string;
  email: string;
  roleId: string;
  roleName: string;
  status: 'active' | 'inactive';
  avatar?: string;
}

export const mockUsers: UserData[] = [
  { id: '1', name: 'John Smith', email: 'john.smith@company.com', roleId: '1', roleName: 'Administrator', status: 'active' },
  { id: '2', name: 'Sarah Johnson', email: 'sarah.johnson@company.com', roleId: '1', roleName: 'Administrator', status: 'active' },
  { id: '3', name: 'Michael Chen', email: 'michael.chen@company.com', roleId: '1', roleName: 'Administrator', status: 'active' },
  { id: '4', name: 'Emily Davis', email: 'emily.davis@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '5', name: 'David Wilson', email: 'david.wilson@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '6', name: 'Lisa Anderson', email: 'lisa.anderson@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '7', name: 'James Martinez', email: 'james.martinez@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '8', name: 'Jennifer Taylor', email: 'jennifer.taylor@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '9', name: 'Robert Brown', email: 'robert.brown@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '10', name: 'Maria Garcia', email: 'maria.garcia@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '11', name: 'William Lee', email: 'william.lee@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '12', name: 'Patricia White', email: 'patricia.white@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '13', name: 'Thomas Harris', email: 'thomas.harris@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '14', name: 'Linda Clark', email: 'linda.clark@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '15', name: 'Christopher Lewis', email: 'christopher.lewis@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '16', name: 'Barbara Robinson', email: 'barbara.robinson@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '17', name: 'Daniel Walker', email: 'daniel.walker@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
  { id: '18', name: 'Nancy Hall', email: 'nancy.hall@company.com', roleId: '3', roleName: 'Approver', status: 'active' },
];

export const mockRoles = {
  '1': {
    id: '1',
    name: 'Administrator',
    description: 'Full system access and control',
    userCount: 3,
    isSystem: true,
    isActive: true,
    permissions: permissionCategories.flatMap(c => c.permissions.map(p => p.id)),
  },
  '2': {
    id: '2',
    name: 'User',
    description: 'Standard user access for time tracking',
    userCount: 145,
    isSystem: true,
    isActive: true,
    permissions: ['dashboard.view_own', 'timesheet.view_own', 'timesheet.create', 'timesheet.edit_own', 'timesheet.delete_own', 'timesheet.submit', 'projects.view_assigned'],
  },
  '3': {
    id: '3',
    name: 'Approver',
    description: 'Can approve timesheets and manage team data',
    userCount: 15,
    isSystem: true,
    isActive: true,
    permissions: ['dashboard.view_own', 'dashboard.view_team', 'timesheet.view_own', 'timesheet.view_team', 'approvals.view_queue', 'approvals.approve', 'approvals.reject', 'reports.view_own', 'reports.view_team'],
  },
};
